import PlainCheckbox from 'app/common/ui-next/plain-checkbox'
import { useAllChecked, useCheckboxActions, useIndeterminate } from './checkbox-hooks'

export const CellContentCheckSimpleAll = ({
  hiddenLabel = 'Выбрать все',
  largeChekbox,
  disabled = false,
  indeterminateAvailable = false,
}: {
  hiddenLabel?: string
  largeChekbox?: boolean
  disabled?: boolean
  indeterminateAvailable?: boolean
}) => {
  const allChecked = useAllChecked()

  const { setAll } = useCheckboxActions()

  const indeterminate = useIndeterminate()

  return (
    <PlainCheckbox
      id={'tableCheckedAll'}
      label={hiddenLabel}
      value={'tableCheckedAll'}
      disabled={disabled}
      checked={allChecked}
      indeterminate={indeterminateAvailable && indeterminate}
      onChange={(event) => setAll(event.currentTarget.checked)}
      large={largeChekbox}
      hideLabel
    />
  )
}
